import React from "react";
import { UnderConstructionWrapper } from "./styled";

const UnderConstruction = () => {
  return (
    <UnderConstructionWrapper>
      <p>UNDER CONSTRICTION</p>
    </UnderConstructionWrapper>
  );
};

export default UnderConstruction;
